'use client';
import { BottomNavigatorContext } from '@/components/organisms/mobile/Reuters.context';
import { PUBLIC } from '@/constants/image/path';
import { getProfile } from '@/hooks/auth';
import LinkFactory from '@/utils/links';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import { useCallback, useContext, useEffect, useState } from 'react';

const Modal = dynamic(() => import('./Modal'), { ssr: false });

const TOTAL_DEFAULT_AVATAR_NUM = 6;

export enum MessageAction {
  Login = 'login',
  Register = 'register',
  More = 'more',
  Close = 'close',
  Tag = 'tag',
  Remount = 'remount'
}

type IframeMessage = {
  type: string;
  message?: boolean | string;
};

const ForexComment = () => {
  const id = getProfile()?.hao_login_id || 0;
  const imgSrc = `${PUBLIC}/icons/avatar/avatars-${(id % TOTAL_DEFAULT_AVATAR_NUM) + 1}.svg`;
  const [isOpen, setIsOpen] = useState(false);
  const [key, remount] = useState(0);
  const context = useContext(BottomNavigatorContext);
  const commentIsOpen = context?.store?.commentIsOpen;
  const setStore = context?.setStore;

  useEffect(() => {
    if (commentIsOpen) handleOpenDrawer();
  }, [commentIsOpen]);

  const onClick = () => {
    setIsOpen(true);
  };

  const handleLogin = () => {
    window.location.href = `${LinkFactory.loginLink}/#?aink=${encodeURIComponent(window.location.href)}`;
  };

  const handleRegister = () => {
    window.location.href = `${LinkFactory.loginLink}/#/register?aink=${encodeURIComponent(window.location.href)}`;
  };

  const handleOpenDrawer = () => {
    setIsOpen(true);
  };

  const handleCloseDrawer = useCallback(() => {
    setIsOpen(false);
    setStore?.(v => ({ ...v, commentIsOpen: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClickTag = (url?: string) => {
    if (url) window.location.href = url;
  };

  const iframeEventListener = useCallback((e: MessageEvent<IframeMessage>) => {
    const iframeMessage = e.data;

    if (typeof iframeMessage !== 'object') return;
    if (!iframeMessage.type) return;

    switch (iframeMessage.type) {
      case MessageAction.Login:
        handleLogin();
        break;
      case MessageAction.Register:
        handleRegister();
        break;
      case MessageAction.More:
        handleOpenDrawer();
        break;
      case MessageAction.Close:
        handleCloseDrawer();
        break;
      case MessageAction.Remount:
        remount(v => v + 1);
        break;
      case MessageAction.Tag:
        const message = iframeMessage?.message as string;

        handleClickTag(message);
        break;
      default:
        break;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    window.addEventListener('message', iframeEventListener, { passive: true });

    return () => {
      window.removeEventListener('message', iframeEventListener);
    };
  }, [iframeEventListener]);

  return (
    <>
      <div className='relative'>
        <iframe
          src={`${LinkFactory.wwwChannelLink}/static/_comments/forex?display=minimized`}
          width='100%'
          height={400}
          scrolling='no'
          key={`main-comment-${key}`}
          title='forex-comment'
        />
        <div className='absolute bottom-0 flex h-[130px] w-full items-end justify-center bg-shadow pb-6'>
          <button
            className='flex h-9 items-center rounded-[19px] bg-white p-[6px] text-[13px] text-[#515c69] shadow-header-navigator'
            onClick={onClick}
          >
            <Image src={imgSrc} width={24} height={24} className='mr-2' alt='user-avatar' />
            點我留言分享你的想法吧～
          </button>
        </div>
      </div>
      <Modal onClose={handleCloseDrawer} isOpen={isOpen}>
        <iframe
          src={`${LinkFactory.wwwChannelLink}/static/_comments/forex`}
          width='100%'
          height='100%'
          title='forex-comment'
          key='drawer-comment'
        />
      </Modal>
    </>
  );
};

export default ForexComment;
